import Question from '../entity/Question';
import Questionnaire from '../entity/Questionnaire';
import IntercomService from '../service/IntercomService';

class QuestionnaireUsecase {
  private intercomService: IntercomService;

  constructor({ intercomService }: { intercomService: IntercomService }) {
    this.intercomService = intercomService;
  }
  public getAdUsQuestionnaire = (): Questionnaire => {
    return new Questionnaire({
      questions: [
        new Question({
          question: 'Monthly Digital Media Spend',
          answerOptions: [
            'Less than $30k',
            '$30k - $100k',
            '$100k - $200k',
            '$200k - $500k',
            '$500k - $1M',
            '$1M - $10M',
            'More than $10M',
          ],
        }),
        new Question({
          question: 'Where did you hear about us?',
          answerOptions: [
            'Facebook Marketing Partner List',
            'Google (Youtube) Partner List',
            'Google (App Campaigns) Partner List',
            'Facebook Referral',
            'Google Referral',
            'Amazon Referral',
            'PPC Entourage Referral',
            'AMZN Consulting Referral',
            'Amazon China',
            'Event Conference',
            'Word of Mouth',
            'Online Search',
            'Case Study / Whitepaper',
            'Saw an Ad',
            'Other',
          ],
        }),
      ],
    });
  };

  public getAdJpQuestionnaire = (): Questionnaire => {
    return new Questionnaire({
      questions: [
        new Question({
          question: 'マーケティング予算(月)',
          answerOptions: [
            '100万円未満',
            '100万円 - 300万円',
            '300万円 - 500万円',
            '500万円 - 1000万円',
            '1000万円より多い',
          ],
        }),
        new Question({
          question: '動画が必要になる時期(目安)',
          answerOptions: [
            '今すぐ動画を制作したい',
            'すぐではないが、3ヶ月以内に制作したい',
            'いまのところ動画を作る予定はない',
            '自社で制作するために事例を知りたい',
          ],
        }),
      ],
    });
  };

  public hideIntercom = (): void => {
    this.intercomService.hide();
  };

  public showIntercom = (): void => {
    this.intercomService.show();
  };
}

export default QuestionnaireUsecase;
